import React, { useEffect, useState } from 'react'
import TopBar from '../Layouts/TopBar'
import Footer from '../Layouts/Footer'
import AllProperties from '../SubComponents/AllProperties'
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import Swal from 'sweetalert2'

const Properties = () => {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem('user'))?.user;
  const token = localStorage.getItem('token');
  const base_url = 'http://localhost:8000';
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleStartChat = async (propertyId, landlordId) => {
    if (!currentUser || !token) {
      Swal.fire({
        title: 'Login Required',
        text: 'Please login to chat with the landlord',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#075E54',
        confirmButtonText: 'Login',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/login');
        }
      });
      return;
    }

    try {
      // First try to find existing conversation
      const response = await axios.get(
        `${base_url}/conversations/find/${propertyId}/`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      if (response.data?.id) {
        // Existing conversation found
        navigate(`/chat/${response.data.id}`);
      } else {
        // Create new conversation
        const newConversation = await axios.post(
          `${base_url}/conversations/`,
          {
            property_id: propertyId,
            landlord_id: landlordId
          },
          { headers: { 'Authorization': `Bearer ${token}` } }
        );

        navigate(`/chat/${newConversation.data.id}`);
      }
    } catch (error) {
      console.error('Error starting chat:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to start chat. Please try again.',
        icon: 'error',
        confirmButtonColor: '#075E54'
      });
    }
  };

  const handleViewProperty = (property) => {
    setSelectedProperty(property);
    setCurrentImageIndex(0);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProperty(null);
    setCurrentImageIndex(0);
  };

  const handleNextImage = () => {
    if (selectedProperty?.images) {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === selectedProperty.images.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  const handlePrevImage = () => {
    if (selectedProperty?.images) {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === 0 ? selectedProperty.images.length - 1 : prevIndex - 1
      );
    }
  };

  return (
    <div>
      <TopBar/>
      <AllProperties onStartChat={handleStartChat} onViewProperty={handleViewProperty} />
      <Footer/>

      {/* Property Details Modal */}
      {showModal && selectedProperty && (
        <div className="property-modal-overlay" onClick={handleCloseModal}>
          <div className="property-modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={handleCloseModal}>
              <i className="fas fa-times"></i>
            </button>

            {/* Image Gallery */}
            <div className="property-gallery">
              {selectedProperty.images && selectedProperty.images.length > 0 ? (
                <>
                  <div className="gallery-main">
                    <img 
                      src={`${base_url}${selectedProperty.images[currentImageIndex].image}`} 
                      alt={`Property ${currentImageIndex + 1}`}
                    />
                    {selectedProperty.images.length > 1 && (
                      <>
                        <button className="gallery-nav prev" onClick={handlePrevImage}>
                          <i className="fas fa-chevron-left"></i>
                        </button>
                        <button className="gallery-nav next" onClick={handleNextImage}>
                          <i className="fas fa-chevron-right"></i>
                        </button>
                      </>
                    )}
                  </div>
                  <div className="gallery-thumbnails">
                    {selectedProperty.images.map((image, index) => (
                      <div 
                        key={index}
                        className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                        onClick={() => setCurrentImageIndex(index)}
                      >
                        <img src={`${base_url}${image.image}`} alt={`Thumbnail ${index + 1}`} />
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="no-image">
                  <i className="fas fa-image"></i>
                  <p>No images available</p>
                </div>
              )}
            </div>

            {/* Property Details */}
            <div className="property-details">
              <h2>{selectedProperty.property_type.charAt(0).toUpperCase() + selectedProperty.property_type.slice(1)}</h2>
              <div className="property-price">
                <i className="fas fa-tag"></i>
                ${selectedProperty.price}/month
              </div>
              <div className="property-location">
                <i className="fas fa-map-marker-alt"></i>
                {selectedProperty.location}
              </div>
              <div className="property-description">
                <h4>Description</h4>
                <p>{selectedProperty.description}</p>
              </div>

              {/* Property Features */}
              <div className="property-features">
                <h6>Features</h6>
                <div className="features-grid">
                  {selectedProperty.bedrooms && (
                    <div className="feature">
                      <i className="fas fa-bed"></i>
                      <span>{selectedProperty.bedrooms} Bedrooms</span>
                    </div>
                  )}
                  {selectedProperty.bathrooms && (
                    <div className="feature">
                      <i className="fas fa-bath"></i>
                      <span>{selectedProperty.bathrooms} Bathrooms</span>
                    </div>
                  )}
                  {selectedProperty.parking_spaces && (
                    <div className="feature">
                      <i className="fas fa-car"></i>
                      <span>{selectedProperty.parking_spaces} Parking</span>
                    </div>
                  )}
                  {selectedProperty.has_wifi && (
                    <div className="feature">
                      <i className="fas fa-wifi"></i>
                      <span>WiFi</span>
                    </div>
                  )}
                  {selectedProperty.is_furnished && (
                    <div className="feature">
                      <i className="fas fa-couch"></i>
                      <span>Furnished</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="property-actions">
                <button 
                  className="chat-btn"
                  onClick={() => handleStartChat(selectedProperty.id, selectedProperty.landlord)}
                >
                  <i className="fas fa-comments"></i>
                  Chat with Landlord
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Properties;
